<template>
  <v-card>
    <v-card-title style="background-color: #004056" class="white--text">
      Open this Lead?
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <div><strong>Yes I want this lead!</strong></div>
      <div class="mt-5">
        Exciting news! For a limited time this lead is <strong>FREE</strong>. 
        Connect with potential clients who need your services.
      </div>
      <div class="mt-5">Don't miss out!</div>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3">
      <v-btn @click="close">Cancel</v-btn>
      <v-btn color="primary" @click="confirm">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'UnopenedLeadFree',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...formatters,

    close() {
      this.$emit('close')
    },

    confirm() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  },

  created() {
    console.log(this.lead)
  }
}
</script>